export default __webpack_public_path__ + "static/media/st.bc2627bb.svg";